export default "__VITE_ASSET__DLI8N5Fw__"